import api from "./api";
// @ts-expect-error - api is not typed
const { get, post } = api.getPrefixedMethods("misc");
export const miscService = {
    regenerateS3Links: (s3Links) => {
        return post("regenerate-s3-links", { s3Links });
    },
    processCMMJson: (data) => {
        return post("process-cmm-json", data);
    },
    reportIssue: (data) => {
        return post("report-issue", data);
    },
    listReportedIssues: (params = {}) => {
        return get("reported-issues", { params });
    },
};
